(function(){
'use strict';
function init(){
  var host=document.getElementById('mbn-src');
  var dataEl=document.querySelector('[data-mbn-data]');
  var form=document.querySelector('.mrs-form')||document.querySelector('form.js-product-form');
  var buy=document.querySelector('.mrs-buy');
  if(!host||!dataEl||!form||!buy||host.dataset.done==='1')return;
  var data;try{data=JSON.parse(dataEl.textContent);}catch(e){return;}
  var vs=data.variants||[];if(!vs.length)return;
  var root=host.querySelector('[data-mbn]');
  form.insertBefore(root,buy);
  host.dataset.done='1';host.remove();
  var cardsWrap=root.querySelector('[data-mbn-cards]');
  var showSize=!!data.showSize;
  var sizes=[],packs=[];
  vs.forEach(function(v){
    if(v.size&&sizes.indexOf(v.size)<0)sizes.push(v.size);
    if(v.pack&&packs.indexOf(v.pack)<0)packs.push(v.pack);
  });
  if(!packs.length)packs=[null];
  function num(s){var m=String(s||'').match(/\d+(\.\d+)?/);return m?parseFloat(m[0]):1;}
  function find(s,p){return vs.filter(function(v){return (s===null||v.size===s)&&(p===null||v.pack===p);})[0];}
  function firstSellable(p){return vs.filter(function(v){return v.pack===p&&v.available;})[0]||find(sizes[0],p);}
  var unitPack=packs.slice().sort(function(a,b){return num(a)-num(b);})[0];
  var maxPack=packs.slice().sort(function(a,b){return num(b)-num(a);})[0];
  var defaultSize=(vs.filter(function(v){return v.available;})[0]||vs[0]).size;
  var selPack=(vs.filter(function(v){return v.available;})[0]||vs[0]).pack;
  if(data.defaultPack&&vs.filter(function(v){return v.pack===data.defaultPack;}).length){selPack=data.defaultPack;}
  var sizesByPack={};
  function ensureSizes(p){
    var n=num(p);
    if(!sizesByPack[p])sizesByPack[p]=[];
    var arr=sizesByPack[p];
    while(arr.length<n)arr.push(defaultSize);
    arr.length=n;
    return arr;
  }
  function apply(){
    var v=firstSellable(selPack);if(!v)return;
    var opt=document.querySelector('.mrs-select__opt[data-variant-id="'+v.id+'"]');
    if(opt){opt.click();}
    else{var hid=document.querySelector('.mrs-variant-id');if(hid)hid.value=v.id;}
  }
  function render(){
    cardsWrap.innerHTML='';
    var baseV=firstSellable(unitPack);
    var base=baseV?baseV.price:0;
    packs.forEach(function(p){
      var v=firstSellable(p);if(!v)return;
      var n=num(p);
      var paid=base>0?Math.round(v.price/base):n;
      if(paid<1)paid=1;if(paid>n)paid=n;
      var free=n-paid;
      var title=free>0?('Buy '+paid+' Get '+free+' FREE'):('Buy '+n);
      var card=document.createElement('label');
      var isSel=(p===selPack);
      card.className='mbn__card'+(isSel?' is-sel':'')+(p===maxPack?' is-best':'')+(v.available?'':' is-out');
      var ribbon='';
      if(p===maxPack){ribbon='<span class="mbn__ribbon">BEST VALUE</span>';}
      else if(data.popular&&p===data.popular){ribbon='<span class="mbn__ribbon mbn__ribbon--pop">MOST POPULAR</span>';}
      card.innerHTML=ribbon+
        '<input type="radio" name="mbn-pack">'+
        '<span class="mbn__radio"></span>'+
        '<span class="mbn__main"><span class="mbn__row"><span class="mbn__title"></span><span class="mbn__badge"></span></span><span class="mbn__sub"></span></span>'+
        '<span class="mbn__price"><span class="mbn__now"></span><span class="mbn__was"></span></span>';
      card.querySelector('.mbn__title').textContent=title;
      card.querySelector('.mbn__badge').textContent=(n>1?(n+' Packs'):(n+' Pack'));
      card.querySelector('.mbn__sub').textContent=(n*2)+' Pairs'+(v.available?'':' — Sold out');
      card.querySelector('.mbn__now').textContent=v.priceFmt;
      var was=card.querySelector('.mbn__was');
      if(v.compare&&v.compare>v.price){was.textContent=v.compareFmt;}else{was.style.display='none';}
      if(showSize&&isSel&&sizes.length){
        var arr=ensureSizes(p);
        var box=document.createElement('span');box.className='mbn__packs';
        arr.forEach(function(cur,i){
          var row=document.createElement('span');row.className='mbn__prow';
          var lab=document.createElement('span');lab.className='mbn__pnum';
          lab.textContent=(n>1?('Pack '+(i+1)):'Size');
          var sel=document.createElement('select');sel.className='mbn__sel';
          sel.setAttribute('aria-label',(n>1?('Size for pack '+(i+1)):'Size'));
          sizes.forEach(function(s){
            var o=document.createElement('option');
            var sv=find(s,unitPack);
            o.value=s;
            o.textContent=s+((sv&&sv.available)?'':' — Out of stock');
            if(!sv||!sv.available)o.disabled=true;
            if(s===cur)o.selected=true;
            sel.appendChild(o);
          });
          sel.addEventListener('click',function(e){e.stopPropagation();});
          sel.addEventListener('change',function(e){e.stopPropagation();arr[i]=sel.value;});
          row.appendChild(lab);row.appendChild(sel);box.appendChild(row);
        });
        card.querySelector('.mbn__main').appendChild(box);
      }
      card.addEventListener('click',function(e){
        if(e.target&&e.target.closest&&e.target.closest('.mbn__sel'))return;
        e.preventDefault();
        if(!v.available)return;
        selPack=p;render();apply();
      });
      cardsWrap.appendChild(card);
    });
  }
  document.addEventListener('click',function(e){
    if(!e.target||!e.target.closest)return;
    if(!e.target.closest('.mrs-buy'))return;
    e.preventDefault();e.stopPropagation();
    var arr=ensureSizes(selPack);
    var counts={};
    arr.forEach(function(s){counts[s]=(counts[s]||0)+1;});
    var items=[];
    Object.keys(counts).forEach(function(s){
      var unit=find(s,unitPack);
      if(unit)items.push({id:unit.id,quantity:counts[s]});
    });
    if(!items.length)return;
    var btn=document.querySelector('.mrs-buy');
    if(btn){btn.disabled=true;}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json();})
      .then(function(){window.location.href='/cart';})
      .catch(function(){if(btn)btn.disabled=false;window.alert('Sorry, we could not add that to your cart. Please try again.');});
  },true);
  render();apply();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
document.addEventListener('shopify:section:load',init);
})();
